/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState, useCallback } from "react";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { toast } from "sonner";
import { Video, ShieldCheck } from "lucide-react";
import { ConsentScreen } from "./ConsentScreen";
import { TelesoinRoom } from "./TelesoinRoom";
import { telesoinError } from "./TelesoinPanel";

/** Côté patient / aidant : prochaine séance de télésoin, information, consentement horodaté, accès à la vidéo sécurisée. */
export function PatientTelesoinCard({ patientId }) {
  const [seance, setSeance] = useState(null);
  const [session, setSession] = useState(null);
  const load = useCallback(() => api.get(`/telesoin/seances?patient_id=${patientId}`).then(({ data }) => setSeance(data.find((s) => ["planifie", "en_cours"].includes(s.statut)) || null)).catch(() => null), [patientId]);
  useEffect(() => { load(); }, [load]);
  const join = async () => {
    try { const { data } = await api.post(`/telesoin/seances/${seance.id}/demarrer`); setSession(data); }
    catch (e) { toast.error(telesoinError(e)); }
  };
  if (!seance) return null;
  return (
    <div data-testid="patient-telesoin-card" className="bg-[#0A1426] rounded-3xl p-5 text-white flex flex-col gap-3">
      <div className="flex items-center gap-2 text-white/80"><Video size={16} /><span className="text-[11px] uppercase tracking-wider font-bold">Séance de télésoin</span></div>
      <div className="font-[Fraunces] text-xl font-bold">{seance.acte_libelle}</div>
      <div className="text-[14px] text-white/85">{new Date(seance.datetime).toLocaleString("fr-FR", { dateStyle: "full", timeStyle: "short" })} · avec {seance.praticien_nom}</div>
      <div className="text-[12px] text-white/70 flex items-center gap-1"><ShieldCheck size={14} className="text-[#5CB85C]" /> Vidéo sécurisée ({seance.fournisseur === "hds" ? "serveur sécurisé" : seance.fournisseur === "doctolib" ? "Doctolib" : "Maiia"}) · acte {seance.lettre_cle} · {Number(seance.montant ?? seance.montant_eur).toFixed(2)} {seance.devise || "€"}</div>
      <div className="bg-white rounded-2xl p-4 text-[#0A1426]">
        <ConsentScreen seance={seance} compact onDone={(c) => setSeance({ ...seance, consentement: c })} />
      </div>
      {seance.consentement && (
        <Button data-testid="patient-telesoin-join-btn" onClick={join} className="w-full h-12 rounded-full bg-[#D4AF5A] text-[#0A1426] font-bold hover:bg-white"><Video size={18} className="mr-2" /> Rejoindre la séance vidéo</Button>
      )}
      {session && <TelesoinRoom seance={seance} session={session} onClose={() => { setSession(null); load(); }} />}
    </div>
  );
}
